import { memo } from "react"
import { Stack, Typography } from "@mui/material"
import { makeStyles } from "tss-react/mui"

import { LocalizedStrict } from "../../../../../../localization/components/AppLocalized"

import { isFieldLocked } from "../../weekMenuLib"
import { WeekDishRow } from "../../weekMenuTypes"
import { PlannerTag, PlannerTagVariant } from "../PlannerTag"

const useStyles = makeStyles()((theme) => ({
    label: {
        height: "100%",
        padding: ".75rem",
        background: theme.palette.background.paper,
        borderBottom: `1px solid ${theme.palette.tailwind.slate[200]}`,
    },
    name: {
        fontWeight: 700,
        color: theme.palette.tailwind.slate[800],
    },
    ready: {
        color: theme.palette.tailwind.slate[500],
    },
    chip: {
        alignSelf: "flex-start",
    },
}))

type Props = Readonly<{
    row: WeekDishRow
    filledCount: number
    totalCount: number
}>

export const DishRowLabel = memo(function DishRowLabel({ row, filledCount, totalCount }: Props) {
    const { classes } = useStyles()

    // Only the text defaults: the locked price has its own chip and the picture shows in each cell.
    const hasTextDefaults =
        row.description.defaultValue !== "" || row.allergens.defaultValue !== "" || row.marketingTag.defaultValue !== ""

    return (
        <Stack spacing=".75rem" className={classes.label}>
            <Typography variant="subtitle2" className={classes.name}>
                {row.name}
            </Typography>
            <LocalizedStrict id="merchant-week-menu-row-ready-label" vars={{ filled: filledCount, total: totalCount }}>
                <Typography variant="caption" className={classes.ready}>
                    {filledCount}/{totalCount} Ready
                </Typography>
            </LocalizedStrict>
            {isFieldLocked(row.price) && row.priceSameAllWeek && (
                <PlannerTag variant={PlannerTagVariant.GLOBAL} className={classes.chip}>
                    <LocalizedStrict
                        id="merchant-week-menu-cell-price-locked-all-week"
                        vars={{ price: row.price.defaultValue }}
                    >
                        <span>{row.price.defaultValue} DKK · all week</span>
                    </LocalizedStrict>
                </PlannerTag>
            )}
            {hasTextDefaults && (
                <PlannerTag variant={PlannerTagVariant.GLOBAL} className={classes.chip}>
                    <LocalizedStrict id="merchant-week-menu-row-template-default-chip">
                        <span>Template default</span>
                    </LocalizedStrict>
                </PlannerTag>
            )}
        </Stack>
    )
})
